<template>
  <div class="secondary d-flex flex-column" style="height: 100vh; width: 100vw">
    <v-btn @click="$emit('close')" icon class="ml-auto" style="">
      <v-icon color="white">mdi-close</v-icon>
    </v-btn>
    <div class="d-flex flex-column align-center justify-center pt-16 px-4">
      <v-icon color="white" size="100"> mdi-medal </v-icon>
      <div class="body-1 white--text text-center">
        {{ $t("general.achievement_dialog") }}<br />
        <v-img> </v-img>
        <div class="body-1 font-weight-bold mt-2">
          {{ route.name }}
        </div>
        <v-img
          class="my-2"
          :aspect-ratio="1"
          :src="'https://iguide.mobics.gr/' + route.main_image"
        ></v-img>

        <v-btn @click="onShare" fab color="accent" x-large class="mt-2">
          <v-icon color="white" size="45">mdi-share</v-icon>
        </v-btn>
      </div>
    </div>

    <!-- <pre>
        {{ route }}
    </pre> -->
  </div>
</template>

<script>
import { decodeEntities } from "@/utils/decodeEntities";
import { Share } from "@capacitor/share";
import { Filesystem, Directory } from "@capacitor/filesystem";
import axios from "axios";

export default {
  props: {
    route: Object,
  },

  methods: {
    async getBase64(url) {
      return axios
        .get(url, {
          responseType: "arraybuffer",
        })
        .then((response) =>
          Buffer.from(response.data, "binary").toString("base64")
        );
    },

    async onShare() {
      const b64image = await this.getBase64(
        "https://iguide.mobics.gr" + this.route.main_image
      );

      //2.  save file in cache
      await Filesystem.writeFile({
        path: "https://iguide.mobics.gr" + this.route.main_image,
        data: b64image,
        directory: Directory.Cache,
        recursive: true,
      });

      //3. get full uri of the saved image
      let imgData = await Filesystem.getUri({
        path: "https://iguide.mobics.gr/" + this.route.main_image,
        directory: Directory.Cache,
      });

      await Share.share({
        title: this.route.name,
        text: this.route.name + "\n\n" + decodeEntities(this.route.description),
        url: imgData.uri,
        dialogTitle: `Share ${this.route.name}`,
      });
    },
  },
};
</script>

<style></style>
